import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import TextField from '@mui/material/TextField';

import { allevaOrangeColor } from '../md/assets/jss/material-dashboard-pro-react.jsx';

const textFieldFillColor = '#f6f6f6';
const inputLabelColor = 'rgba(0, 0, 0, 0.54)';
const allevaOrange = allevaOrangeColor[0];

const useStyles = makeStyles((theme) => ({
  root: {
    // margin: theme.spacing(1),
    '& .MuiInputLabel-shrink': {
      color: inputLabelColor,
    },
    '& .MuiFilledInput-underline:after': {
      borderBottomColor: theme.palette.secondary.main,
    },
  },
}));

const CrmTextField = ({
  className,
  id,
  required,
  fullWidth,
  multiline,
  label,
  placeholder,
  autoFocus,
  error,
  disabled,
  readOnly,
  password,
  inputProps,
  onClick,
  value,
  onChange,
  onKeyUp,
  showingAutoFill,
}) => {
  const classes = useStyles();
  const helperText = error ? 'explanation' : '';
  const setAutoFocus = !!autoFocus;
  const color = readOnly ? 'primary' : 'secondary';
  const setDisabled = readOnly ? true : disabled;
  const typeProps = { type: password ? 'password' : 'text' };
  const lowerInputProps = inputProps ? { ...inputProps, ...typeProps } : typeProps;
  const capitalInputProps = readOnly
    ? { style: { backgroundColor: '#fff' } }
    : { style: { backgroundColor: textFieldFillColor } };
  const oC = readOnly ? () => {} : onChange;
  let classesToInject = classes.root;
  if (className) {
    classesToInject += ' ' + className;
  }
  const autoFillVal = showingAutoFill ? 'on' : 'new-password';
  const inputLabelProps = required ? { style: { color: allevaOrange } } : {};
  return (
    <TextField
      className={classesToInject}
      id={id}
      label={label}
      required={required}
      fullWidth={fullWidth}
      multiline={multiline}
      placeholder={placeholder}
      autoFocus={setAutoFocus}
      variant="filled"
      color={color}
      error={error}
      helperText={helperText}
      disabled={setDisabled}
      inputProps={lowerInputProps}
      InputProps={capitalInputProps}
      onClick={onClick}
      value={value}
      onChange={oC}
      onKeyUp={onKeyUp}
      autoComplete={autoFillVal}
      InputLabelProps={inputLabelProps}
    />
  );
};

/*
 * The property " autoComplete='new-password' " above is a sort of hack documented at
 * https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
 */

export default CrmTextField;
